<template>
  <div>
    <el-date-picker v-model="value" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="center" size="small" :picker-options="pickerOptions2" value-format="yyyy-MM-dd HH:mm:ss" />
  </div>
</template>

<script>
export default {
  name: 'input-date-picker',
  props: {
    dataValue: Array
  },
  data () {
    return {
      value: [],
      pickerOptions2: {
        shortcuts: [{
          text: '未来一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '未来三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '未来一年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 365)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '未来三年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 3)
            picker.$emit('pick', [start, end])
          }
        }]
      },
    }
  },
  mounted () {
    this.value = this.dataValue
  },
  watch: {
    value () {
      this.$emit('getCardTime', this.value)
    }
  }
}
</script>

<style scoped>
.selectTitle {
  display: inline-block;
  color: #48576a;
  font-size: 14px;
  line-height: 32px;
  margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Input/InputDatePicker.vue